import Authenticated from '@/Layouts/Authenticated';
import { Head } from '@inertiajs/inertia-react';
import AbstractSignupArtwork from "@/Components/AbstractSignupArtwork";
import i18n from 'i18next';
import { usePage } from "@inertiajs/inertia-react";

export default function WelcomeToOrganization()
{
    const app_name = usePage().props.app_name;
    const module_name = usePage().props.module_name;
    const organization_name = usePage().props.organization_name;
    const learn_more_url = usePage().props.learn_more_url;
    let welcome_message = 'welcome-to-organization.amplify-message';
    let welcome_to_organization_title = 'welcome-to-organization.amplify-title';
    if (app_name.trim() === "ParishSOFT"){
        welcome_message = 'welcome-to-organization.parishsoft-message';
        welcome_to_organization_title = 'welcome-to-organization.parishsoft-title';
    }

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <Head title={ i18n.t('welcome-to-organization.page_title', { org_name: organization_name })}/>
            <AbstractSignupArtwork/>

            <div className={"welcome-to-organization"}>
                {/* Welcome Title */}
                <div className={"col-md-12 text-center title"}>
                    <h3 className={"fw-bold"}>
                        { i18n.t(welcome_to_organization_title, { app_name: app_name, module_name: module_name }) }
                    </h3>
                </div>
                {/* Welcome Title Ends */}

                {/* Welcome Message */}
                <div className={"col-md-12 text-center mt-3"}>
                    <span>{i18n.t(welcome_message)}</span>
                </div>
                {/* Welcome Message Ends */}

                {/* Set Password Button */}
                <div className={"col-md-12 text-center mt-5"}>
                    <a className="w-100 btn btn-primary text-white"
                       href={route('password.set.create')}
                    >
                        { i18n.t('welcome-to-organization.reset-password') }
                    </a>
                    <span className={"d-block mt-3"}>
                        { i18n.t('welcome-to-organization.learn-more', { app_name: app_name }) }
                        <a href={learn_more_url} target={"_blank"}>{app_name}</a>
                    </span>
                </div>
                {/* Set Password Button Ends */}

            </div>
        </Authenticated>
    );
}
